import React from 'react'

import {
	CardAction,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/shared/components/ui/card'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

export default function WidgetHeader({
	title,
	tooltip,
	subtitle,
	children,
	className,
}: {
	children?: React.ReactNode
	tooltip?: string
	title?: string
	//titleAs?: React.ElementType
	subtitle?: string
	className?: string
} & React.HTMLAttributes<HTMLDivElement>) {
	return (
		<CardHeader className={className}>
			<Tooltip>
				<TooltipTrigger asChild>
					<CardTitle className='text-sm'>{title}</CardTitle>
				</TooltipTrigger>
				<TooltipContent
					collisionBoundary={
						document.getElementById('dashboard-container') || undefined
					}
				>
					{tooltip}
				</TooltipContent>
			</Tooltip>
			{subtitle && (
				<CardDescription className='line-clamp-2 text-xs whitespace-normal'>
					{subtitle}
				</CardDescription>
			)}
			<CardAction>{children}</CardAction>
		</CardHeader>
	)
}
